import script from "./UserCredito.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCredito.vue?vue&type=script&setup=true&lang=js"

import "./UserCredito.vue?vue&type=style&index=0&id=2dc28c78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc28c78"]])

export default __exports__